export default "__VITE_ASSET__16fcce4e__"